<template>
  <b-container class="col-md-12 mx-auto">
    <div>
      <div class="mt-4 d-flex justify-content-between">
        <back-arrow :confirm="askConfirm" :params="{operationId: operationId}"
                    :title="$t('Modify') + ' ' + $t('a') + ' ' + $t('operationDocument')"
                    route-back="OperationShowDocuments"/>
      </div>
      <div class="row">
        <div class="col-md-12">
          <b-card class="mt-2 mb-4 shadow-sm">
            <b-form v-unsave-detector @submit.stop.prevent="onSubmit">
              <div class="row">
                <div class="col-md-6">
                  <b-form-group
                    :invalid-feedback="document.newFile.invalidFeedback"
                    :label="$t('OperationDocument')"
                    :state="document.newFile.state"
                    class="medium-label mb-4"
                    label-for="document-file">
                    <custom-form-file
                      id="document-file"
                      v-model="document.newFile.value"
                      :browse-text="$t('Select')"
                      :disabled="document.date.value !== null && new Date(document.date.value) <= minDate"
                      :placeholder="document.file.value ? document.file.value : $t('Select') + ' ' + $t('a') + ' ' + $t('contactDocument.file')"
                      :required="document.id == null"
                      :state="document.newFile.state"
                      @preview="imagePreview = $event"
                      @input="setName()">
                    </custom-form-file>
                    <div class="mt-2">
                      <img v-if="imagePreview" :src="imagePreview" alt="Image preview"
                           class=" mt-1 preview-image"/>
                      <img v-else-if="document.file && document.file.fileUrl && isPreviewable(document.file.extension)"
                           :src="getFileUrl(document.file.fileUrl)" alt="Image preview"
                           class="mt-1 preview-image"/>
                      <a v-else-if="document.file && document.file.fileUrl"
                         :href="getFileUrl(document.file.fileUrl)" target="_blank">
                        {{ document.file.value }}</a>
                    </div>
                  </b-form-group>
                </div>
                <div class="col-md-6">
                  <b-form-group
                    :label="$t('OperationDocument.name')"
                    class="medium-label mb-4"
                    label-for="document-name">
                    <b-form-input
                      id="document-name"
                      v-model="document.name.value"
                      :disabled="document.date.value !== null && new Date(document.date.value) <= minDate"
                      maxlength="250"
                      required
                      type="text"
                      v-on:change="askConfirm=true;">
                    </b-form-input>
                  </b-form-group>
                </div>
                <div class="col-md-4">
                  <b-form-group
                    :label="$t('Dossier')"
                    class="medium-label mb-4"
                    label-for="dossier-input">
                    <b-form-select
                      id="dossier-input"
                      v-model="document.selectedFolderId.value"
                      v-on:change="askConfirm=true;">
                      <option v-for="folder in folderList" :value="folder.id">
                        {{ $t(folder.name) }}
                      </option>
                    </b-form-select>
                  </b-form-group>
                </div>
                <div class="col-md-4">
                  <b-form-group
                    :label="$t('OperationDocument.deadlineDate')"
                    class="medium-label mb-4"
                    label-for="document-date">
                    <datepicker-input
                      id="document-date"
                      v-model="document.date.value"
                      :disabled="document.date.value !== null && new Date(document.date.value) <= minDate"
                      :min="minDate"
                      v-on:change="askConfirm=true;">
                    </datepicker-input>
                  </b-form-group>
                </div>
                <div class="col-md-4">
                  <b-form-group
                    :label="$t('AVP / EXE')"
                    class="medium-label mb-4"
                    label-for="avpexe-input">
                    <b-form-select
                      id="avpexe-input"
                      v-model="document.avpexevalue">

                      <option value="general">Général à tous les lots</option>
                      <option value="avp">AVP</option>
                      <option value="exe">EXE</option>
                      <option value="avpexe">Les deux</option>
                    </b-form-select>
                  </b-form-group>
                </div>
                <div class="col-md-12">
                  <b-form-group
                    v-if="document.avpexevalue !== 'general'"
                    :label="$t('operationConstructions.lots.tolink')"
                    :label-for="'lots-input'"
                    class="medium-label mb-2">

                    <div :id="'lots-input'" class="custom-container">
                      <template v-for="(operationLot, index) in operationLots">
                        <b-form-checkbox
                          v-if="operationLot.bilanType === document.avpexevalue.toUpperCase() || document.avpexevalue === 'avpexe'"
                          class="ml-2"
                          :key="operationLot.id + '-' + document.selectedLots.includes(operationLot.id)"
                          :ref="'checkbox' + operationLot.id + operationDocumentId"
                          :checked="document.selectedLots && document.selectedLots.includes(operationLot.id)"
                          @change="handleCheckboxChange(operationLot.id)">
                            <span v-if="operationLot.lotCoPro">
                              {{ $t('operation.bilan.Lot') + ' ' + operationLot.lotCoPro }}
                            </span>
                          <span v-else>{{ $t('operation.bilan.Lot') + ' ' + operationLot.lotNumber }}</span>
                          -{{operationLot.bilanType}}
                        </b-form-checkbox>
                      </template>
                    </div>
                  </b-form-group>
                </div>
              </div>

              <div class="d-flex justify-content-end">
                <b-button type="submit" variant="primary">{{ $t('Update') }}</b-button>
              </div>

            </b-form>
          </b-card>
        </div>
      </div>
    </div>
  </b-container>
</template>

<script>
import backArrow from "../../components/b122/BackArrow";
import api from "../../services/api";
import DatepickerInput from "../../components/b122/editFields/DatepickerInput.vue";
import CustomFormFile from "../../components/b122/editFields/CustomFormFile.vue";

export default {
  name: "OperationDocumentEdit",

  components: {
    backArrow,
    DatepickerInput,
    CustomFormFile
  },

  data() {
    return {
      operationId: this.$route.params.operationId,
      operationDocumentId: this.$route.params.operationDocumentId,
      minDate: null,
      askConfirm: false,
      operationLots: [],
      folderList: [],
      document: {
        id: null,
        newFile: {
          state: null,
          invalidFeedback: null,
          value: null
        },
        name: {
          state: null,
          invalidFeedback: null,
          value: null
        },
        date: {
          state: null,
          invalidFeedback: null,
          value: null
        },
        file: {
          state: null,
          invalidFeedback: null,
          value: null
        },
        selectedFolderId:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        avpexevalue: "avpexe",
        selectedLots: [],
      },
      imagePreview: null

    }
  },

  watch: {
    operationId: function () {
      this.getFolders()
    }
  },

  async mounted() {

    await this.setDate()

    this.operationDocumentId = this.$route.params.operationDocumentId
    this.operationId = this.$route.params.operationId

    if(this.operationId){
      await this.getFolders()
    }

    if(this.operationDocumentId){
      await this.fetchDocument()
    }
    if(this.operationId){
      await this.getOperationLots()
    }
  },

  methods: {

    async getOperationLots() {
      await api
        .get(`/operationDocument/getAllForOperation/${this.operationId}`)
        .then(response => {
          this.operationLots = response.data
        })
    },

    getFolders() {
      api.get('/operationDocument/getOperationFoldersWithoutDevisAndFactures/' + this.operationId).then(response => {
        this.folderList = response.data
      });
    },

    setName() {
      this.document.name.value = this.document.newFile.value.name
    },

    async setDate() {
      const now = new Date()
      this.minDate = new Date(now.getFullYear(), now.getMonth(), now.getDate())
    },

    async fetchDocument() {
      await api({
        method: 'GET',
        url: `/operationDocument/${this.operationDocumentId}`
      })
        .then((response) => {
          this.document.name.value = response.data.name
          this.document.date.value = response.data.deadlineDate
          this.document.file.value = response.data.file.fileName
          this.document.file.fileUrl = response.data.file.fileUrl
          this.document.file.extension = response.data.file.extension
          this.document.id = response.data.id
          this.document.selectedFolderId.value = response.data.folderId
          this.document.selectedLots = JSON.parse(response.data.selectedLots)
          this.document.avpexevalue = response.data.avpExeMode
          if(!this.operationId){
            this.operationId = response.data.operation.id
          }
        })
    },

    isPreviewable(extension) {
      const previewableExtensions = ['.jpg', '.jpeg', '.png', '.gif'];
      return previewableExtensions.includes(extension.toLowerCase());
    },

    async onSubmit() {
      let data = new FormData()
      if(this.document.newFile && this.document.newFile.value){
        data.append('document', this.document.newFile.value)
      }
      data.append('documentDate', this.document.date.value)
      data.append('documentName', this.document.name.value)
      data.append('operationId', this.operationId)
      data.append('documentId', this.operationDocumentId)
      data.append('selectedFolderId', this.document.selectedFolderId.value)
      data.append('selectedLots', JSON.stringify(this.document.selectedLots))
      data.append('avpExeValue', this.document.avpexevalue)

      api({
        method: 'POST',
        url: `/operationDocument/${this.document.id}`,
        data: data
      })
        .then((response) => {
          this.$router.push({
            name: 'OperationShowDocuments',
            params: {
              operationId: this.operationId,
              currentSection: 2
            }
          }, () => {
            this.$nextTick(() => {
              this.successToast()
            })
          })
        })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'OperationDocumentCreate',
              params: {
                operationId: this.operationId,
                currentSection: 2,
                allowCreate: this.allowCreate,
                preFill: this.preFill
              }
            })
          } else if (error.response.status === 403) {
            const invalidField = error.response.data.invalidField
            this.document[invalidField]['state'] = false
            this.document[invalidField]['invalidFeedback'] = this.$i18n.t(error.response.data.message)
          }
        })
    },

    getFileUrl(itemUrl) {
      return process.env.SERVER_URL + itemUrl
    },

    successToast() {
      this.$bvToast.toast(this.$i18n.t('Document') + ' ' + this.$i18n.t('registered.object'), {
        autoHideDelay: 4000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true,
        variant: "success",
        solid: true,
      })
    },

    handleCheckboxChange(lotId) {
      const index = this.document.selectedLots.indexOf(lotId);
      if (index === -1) {
        this.document.selectedLots.push(lotId);
      } else {
        if (this.document.selectedLots.length > 1) {
          this.document.selectedLots.splice(index, 1);
        } else {
          this.$refs["checkbox" + lotId + this.operationDocumentId][0].checked = true;
          this.$refs["checkbox" + lotId + this.operationDocumentId][0].computedLocalChecked = true;
          this.$refs["checkbox" + lotId + this.operationDocumentId][0].localChecked = true;
        }
      }
    },
  }
}
</script>

<style scoped>
.custom-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
</style>



// WEBPACK FOOTER //
// src/views/operationDocument/OperationDocumentEdit.vue